/**
 *@desc gallery-api
 *@author XinD
 *@date 2022/11/8
 */
import Axios from "@/utils/Axios";
import config from "@/config";
import { buriedPointGeneralParameters, generateUUID, MsgRevProps } from "@/utils/buried";
import { loginStore } from "@/modules/login/store";
import { ServerPostItemType } from "@/modules/editor/request";
export interface GetPromptListType {
  page_size: number;
  page_index: number;
  seed?: string;
  keywords: string;
  sort?: string;
  author?: string;
  collapse?: boolean;
  image_id?: number;
}
export interface GetPromptDetailType {
  image_id: number | string;
}
export interface PostLikesAddType {
  image_id: number;
}
export interface PostCollectionsAddType {
  image_id?: number;
  group_name?: string;
}
export interface PostCollectionsRemoveType {
  image_id?: number;
}
export interface PostFollowCreateType {
  to_user_id: string;
}
export interface PostPromptViewType {
  image_id?: number;
}
export interface PostOpusDetailType {
  opus_id: number;
}
export interface PostOpusDelProps {
  opus_id: number;
}
interface OpusImageType {
  ImageUrl: string;
  IsAi: boolean;
  MetaJson: unknown;
}
export interface PostOpusPublishProps {
  title?: string;
  describe: string;
  is_open: boolean;
  opus_id: number;
  opus_image: OpusImageType[];
}
export interface PostReportOpusProps {
  image_id: number;
  report_type: string;
  report_reasons?: string;
}
// Gallery-Post
export function getPromptList(data: GetPromptListType) {
  return Axios.post(`/prompt/list`, data, {}, config.aiCreator);
}
// Gallery-Detail-Post
export function getPromptDetail(data: GetPromptDetailType) {
  return Axios.post(`/prompt/detail`, data, {}, config.aiCreator);
}
// 点赞-Add-Post
export function postLikesAdd(data: PostLikesAddType) {
  return Axios.post(`/likes/add`, data, {}, config.aiCreator);
}
// 取消点赞-Post
export function postLikesCancel(data: PostLikesAddType) {
  return Axios.post(`/likes/cancel`, data, {}, config.aiCreator);
}
// 收藏-Post
export function postCollectionsAdd(data: PostCollectionsAddType) {
  return Axios.post(`/collections/add`, data, {}, config.aiCreator);
}
// 取消收藏-Post
export function postCollectionsRemove(data: PostCollectionsRemoveType) {
  return Axios.post(`/collections/remove`, data, {}, config.aiCreator);
}
// 关注-Post
export function postFollowCreate(data: PostFollowCreateType) {
  return Axios.post(`/follow/create`, data, {}, config.aiCreator);
}
// 取消关注-Post
export function postFollowCancel(data: PostFollowCreateType) {
  return Axios.post(`/follow/cancel`, data, {}, config.aiCreator);
}

/**
 * @deprecated
 * @description 添加消息记录-埋点
 * @param data
 * @returns
 */
export const postMsgRev = (data?: MsgRevProps) => {
  return Axios.post(
    "/msg_rev",
    {
      type_name: "event_point",
      uniq_id: generateUUID(),
      msg: {
        generalParameters: {
          user_id: loginStore?.userState?.userInfo?.userId ?? localStorage.noliUserId,
          ...buriedPointGeneralParameters,
        },
        eventParameters: {
          ...data?.eventParameters,
        },
        otherParameters: {
          ...data?.otherParameters,
        },
      },
    },
    {},
    config.dbusService,
  );
};
// 用户查看量-Post
export function postPromptView(data: PostPromptViewType) {
  return Axios.post(`/prompt/view`, data, {}, config.aiCreator);
}
// 查询作品详情-Post
export function postOpusDetail(data: { opus_id: number }) {
  return Axios.post(`/opus/detail`, data, {}, config.aiCreator);
}
// 删除作品-Post
export function postOpusDel(data: { opus_id: number; del_type: number }) {
  return Axios.post(`/opus/del`, data, {}, config.aiCreator);
}
// 发布作品-Post
export function postOpusPublish(data: {
  opus_id: number;
  is_open: 1 | 2;
  describe: string;
  title: string;
  opus_image: ServerPostItemType[];
}) {
  return Axios.post(`/opus/update`, data, {}, config.aiCreator);
}
// 查询举报类型-Get
export function getReportType() {
  return Axios.get(`/query/report_type`, "", {}, config.aiCreator);
}
// 举报作品-Post
export function postReportOpus(data: PostReportOpusProps) {
  return Axios.post(`/report/opus`, data, {}, config.aiCreator);
}
// 检测是否存在默认画册(登陆成功调取，用户创建默认画册)-Post
export function postCheckAlbum() {
  return Axios.post("/check/album", {}, {}, config.creatorUrl);
}
